import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import DoctorSidebar from "./DoctorSidebar";
import DoctorNavbar from "./DoctorNavbar";

const DoctorLayout = () => {
  const [doctor, setDoctor] = useState(null);
  const [notifCount, setNotifCount] = useState(0);
  const navigate = useNavigate();

  const doctorId = localStorage.getItem("doctorId");

  // Fetch doctor info
  const fetchDoctorInfo = async () => {
    try {
      const res = await fetch(`https://ricgop.onlein/api/get-doctor-info.php?doctor_id=${doctorId}`);
      const data = await res.json();
      if (data?.doctor) {
        setDoctor(data.doctor);
      } else {
        navigate("/doctor/login");
      }
    } catch (err) {
      navigate("/doctor/login");
    }
  };

  // Fetch unseen appointments count
  const fetchNotificationCount = async () => {
    const res = await fetch(`https://ricgop.onlein/api/appointment-notifications.php?doctor_id=${doctorId}`);
    const data = await res.json();
    setNotifCount(data?.newAppointments || 0);
  };

  useEffect(() => {
    if (!doctorId) {
      navigate("/doctor/login");
      return;
    }
    fetchDoctorInfo();
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 15000); // refresh every 15s
    return () => clearInterval(interval);
  }, []);

  if (!doctor) return <div className="p-5">Loading doctor panel...</div>;

  return (
    <div className="d-flex">
      <DoctorSidebar />
      <div className="flex-grow-1">
        <DoctorNavbar doctor={doctor} notificationCount={notifCount} />
        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DoctorLayout;
